function initSingleSlider(slider) {
  if (slider.dataset.rsInitialized) return;
  slider.dataset.rsInitialized = '1';

    const minValueInput = slider.querySelector(".js-min-value-input");
    const maxValueInput = slider.querySelector(".js-max-value-input");
    const sliderData = slider.querySelector(".js-number-property-slider-data");

    if (!minValueInput || !maxValueInput || !sliderData) return;

    let minValue = parseInt(sliderData.dataset.min_value);
    const maxValue = parseInt(sliderData.dataset.max_value);
    let startValue = parseInt(sliderData.dataset.start_value);
    let endValue = parseInt(sliderData.dataset.end_value);

    if (minValue === maxValue) { minValue = minValue - 1; }
    if (startValue === endValue) { startValue = startValue - 1; }

    startValue = Math.max(minValue, Math.min(startValue, maxValue));
    endValue = Math.max(minValue, Math.min(endValue, maxValue));

    const step = Math.max(1, Math.round((maxValue - minValue) / 500));

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    sliderData.parentNode.insertBefore(hiddenInput, sliderData);

    const rsInstance = new rSlider({
      target: hiddenInput,
      values: { min: minValue, max: maxValue },
      step: step,
      range: true,
      tooltip: false,
      set: [startValue, endValue],
      onChange: function() {
        const parts = hiddenInput.value.split(',');
        minValueInput.value = parts[0];
        maxValueInput.value = parts[1];
      }
    });

    minValueInput.addEventListener('change', function() {
      const typed = parseInt(this.value);
      if (isNaN(typed)) return;
      const newMin = Math.max(minValue, Math.min(Math.round((typed - minValue) / step) * step + minValue, maxValue));
      const curMax = parseInt(maxValueInput.value) || endValue;
      rsInstance.setValues(newMin, curMax);
    });

    maxValueInput.addEventListener('change', function() {
      const typed = parseInt(this.value);
      if (isNaN(typed)) return;
      const curMin = parseInt(minValueInput.value) || startValue;
      const newMax = Math.max(minValue, Math.min(Math.round((typed - minValue) / step) * step + minValue, maxValue));
      rsInstance.setValues(curMin, newMax);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  const mobileFilter = document.querySelector('.mobile-filter');

  // Инициализируем слайдеры только вне мобильного фильтра
  document.querySelectorAll('.js-number-property-slider').forEach(function(slider) {
    if (mobileFilter && mobileFilter.contains(slider)) return;
    initSingleSlider(slider);
  });

  // Слайдеры внутри мобильного фильтра — при первом открытии
  const filterBtn = document.querySelector('.filter-btn');
  if (filterBtn && mobileFilter) {
    let initialized = false;
    filterBtn.addEventListener('click', function() {
      if (initialized) return;
      requestAnimationFrame(function() {
        mobileFilter.querySelectorAll('.js-number-property-slider').forEach(initSingleSlider);
        initialized = true;
      });
    });
  }
});
